module.exports = __webpack_public_path__ + "static/media/dropdownPaginationArrow.1621bf7f.svg";